import { render, staticRenderFns } from "./flag-component.vue?vue&type=template&id=6582d5e1&scoped=true&"
import script from "./flag-component.vue?vue&type=script&lang=js&"
export * from "./flag-component.vue?vue&type=script&lang=js&"
import style0 from "./flag-component.vue?vue&type=style&index=0&id=6582d5e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6582d5e1",
  null
  
)

export default component.exports